import React from 'react'
import Icon from './Icon'

const Remove = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="M20,12 C24.411,12 28,15.589 28,20 C28,24.411 24.411,28 20,28 C15.589,28 12,24.411 12,20 C12,15.589 15.589,12 20,12 Z M20,27 C23.86,27 27,23.86 27,20 C27,16.14 23.86,13 20,13 C16.14,13 13,16.14 13,20 C13,23.86 16.14,27 20,27 Z M23.8535,16.1465 C24.0485,16.3415 24.0485,16.6585 23.8535,16.8535 L20.7075,20.0005 L23.8535,23.1465 C24.0485,23.3415 24.0485,23.6585 23.8535,23.8535 C23.7555,23.9515 23.6275,24.0005 23.4995,24.0005 C23.3725,24.0005 23.2445,23.9515 23.1465,23.8535 L19.9995,20.7075 L16.8535,23.8535 C16.7555,23.9515 16.6275,24.0005 16.4995,24.0005 C16.3725,24.0005 16.2445,23.9515 16.1465,23.8535 C15.9515,23.6585 15.9515,23.3415 16.1465,23.1465 L19.2925,20.0005 L16.1465,16.8535 C15.9515,16.6585 15.9515,16.3415 16.1465,16.1465 C16.3415,15.9515 16.6585,15.9515 16.8535,16.1465 L19.9995,19.2925 L23.1465,16.1465 C23.3415,15.9515 23.6585,15.9515 23.8535,16.1465 Z" />
    </g>
  </Icon>
)

export default Remove



// WEBPACK FOOTER //
// ./icons/Remove.js